import React, { useState, useEffect } from "react";
import {
  getServices,
  addService,
  updateService,
  deleteService,
} from "./firestoreServices";

const ServicesDashboard = () => {
  const [services, setServices] = useState([]);
  const [form, setForm] = useState({
    icon: "⚖️",
    ar: { title: "", desc: "" },
    en: { title: "", desc: "" },
  });
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    load();
  }, []);
  const load = async () => {
    setServices(await getServices());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editId) await updateService(editId, form);
    else await addService(form);
    setForm({
      icon: "⚖️",
      ar: { title: "", desc: "" },
      en: { title: "", desc: "" },
    });
    setEditId(null);
    load();
  };

  const handleEdit = (item) => {
    setForm(item);
    setEditId(item.id);
  };
  const handleDelete = async (id) => {
    await deleteService(id);
    load();
  };

  return (
    <div className="dashboard-container">
      <h2 className="page-title">إدارة الخدمات</h2>

      {/* Form */}
      <div className="admin-card">
        <h3 className="form-title">
          {editId ? "تعديل خدمة" : "إضافة خدمة جديدة"}
        </h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>الأيقونة (Emoji)</label>
            <input
              className="admin-input"
              value={form.icon}
              onChange={(e) => setForm({ ...form, icon: e.target.value })}
            />
          </div>

          <div className="form-grid">
            <div>
              <label>العنوان (عربي)</label>
              <input
                className="admin-input"
                required
                value={form.ar.title}
                onChange={(e) =>
                  setForm({
                    ...form,
                    ar: { ...form.ar, title: e.target.value },
                  })
                }
              />
              <label style={{ marginTop: "10px" }}>الوصف (عربي)</label>
              <textarea
                className="admin-textarea"
                required
                value={form.ar.desc}
                onChange={(e) =>
                  setForm({ ...form, ar: { ...form.ar, desc: e.target.value } })
                }
              />
            </div>
            <div>
              <label>Title (English)</label>
              <input
                className="admin-input"
                required
                value={form.en.title}
                onChange={(e) =>
                  setForm({
                    ...form,
                    en: { ...form.en, title: e.target.value },
                  })
                }
                dir="ltr"
              />
              <label style={{ marginTop: "10px" }}>Description (English)</label>
              <textarea
                className="admin-textarea"
                required
                value={form.en.desc}
                onChange={(e) =>
                  setForm({ ...form, en: { ...form.en, desc: e.target.value } })
                }
                dir="ltr"
              />
            </div>
          </div>

          <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
            <button className="btn btn-primary">
              {editId ? "حفظ التعديلات" : "إضافة"}
            </button>
            {editId && (
              <button
                type="button"
                onClick={() => {
                  setEditId(null);
                  setForm({
                    icon: "⚖️",
                    ar: { title: "", desc: "" },
                    en: { title: "", desc: "" },
                  });
                }}
                className="btn btn-secondary"
              >
                إلغاء
              </button>
            )}
          </div>
        </form>
      </div>

      {/* List */}
      <div className="items-grid">
        {services.map((s) => (
          <div key={s.id} className="grid-item">
            <div style={{ fontSize: "40px", marginBottom: "10px" }}>
              {s.icon}
            </div>
            <h3>{s.ar.title}</h3>
            <p
              style={{ fontSize: "13px", color: "#666", marginBottom: "15px" }}
            >
              {s.ar.desc.substring(0, 60)}...
            </p>
            <div className="item-actions">
              <button
                onClick={() => handleEdit(s)}
                className="btn btn-secondary btn-action"
              >
                تعديل
              </button>
              <button
                onClick={() => handleDelete(s.id)}
                className="btn btn-danger btn-action"
              >
                حذف
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default ServicesDashboard;
